import { useCallback, useEffect } from "react";
import { observer } from "mobx-react-lite";
import Stack from "@mui/joy/Stack";
import Typography from "@mui/joy/Typography";
import Tooltip from "@mui/joy/Tooltip";
import Skeleton from "@mui/joy/Skeleton";
import Chip from "@mui/joy/Chip";

import LockedFeature from "components/LockedFeature";
import {Success} from "components/FancyToast";

import IdentityAvatar from "components/IdentityAvatar";

import useIdentity from "hooks/useIdentity";

import getIcon from "utils/getIcon";
import phoneFormat from "utils/phoneFormat"
import useUserIdentity from "hooks/useUserIdentity";
import useRoles from "hooks/useRoles";


const SidebarIdentityInfo = observer(({ identityKey }: { identityKey: string }) => {
    const EmailIcon = getIcon('Email');
    const { fetchIdentity, getIdentity } = useIdentity();
    const { currentIdentity } = useUserIdentity();
    const { hasRole } = useRoles();
    const identity = getIdentity(identityKey || '');
    const runFetchIdentity = useCallback(() => {
        if (identityKey && currentIdentity?.uuid) {
            fetchIdentity(currentIdentity?.uuid, identityKey);
        }
    }, [fetchIdentity, identityKey, currentIdentity?.uuid]);
    useEffect(() => {
        runFetchIdentity();
    }, [runFetchIdentity]);

    if (!identity) {
        return <Skeleton width={85} variant="text" />
    }

    return (
        <Stack spacing={1} pb={2} >
            <Stack
                pb={1}
                direction="row"
                justifyContent="center">
            </Stack>

            <LockedFeature
                lockedIconName="PersonPin"
                unlockedIconName="LockPerson"
                copy={identity.name}>
                <Stack
                    mx={1}
                    alignItems="center"
                    spacing={2}>

                    <Typography level="title-lg">
                <IdentityAvatar size="inline" interactive={"link"}
                    identityKey={identityKey} />
                    </Typography>

                    <Stack>
                    <Typography
                        sx={{ textTransform: 'uppercase' }}
                        level="body-xs">Email</Typography>

            <Tooltip arrow title="Copy to clipboard">
                <Typography
                    mx={0.5}
                    sx={{ cursor: 'default' }}
                    level="body-sm"
                    color="primary"
                    startDecorator={<EmailIcon />}
                    onClick={() => {
                        navigator.clipboard.writeText(identity.email);
                        Success("Copied to clipboard");
                    }}>
                        { identity.email }

                        </Typography>
                        </Tooltip>
                        </Stack>
                    { identity.phone &&
                        <>
                            <Typography
                        sx={{ textTransform: 'uppercase' }}
                        level="body-xs">Phone</Typography>
                    <Typography
                        level="body-xs">
                        { phoneFormat(identity.phone) }
                    </Typography>
                        </>
                    }

                    { (identity.addr1 ||
                        identity.addr2 ||
                        identity.city ||
                        identity.state ||
                        identity.zipcode) &&
                        <Stack>
                            <Stack my={1}>
                                <Typography
                                    sx={{ textTransform: 'uppercase' }}
                                    level="body-xs">Address</Typography>
                            </Stack>
                                { identity.addr1 &&
                                <Typography
                                    level="body-xs">
                                 { identity.addr1 }
                                </Typography>
                                }

                                { identity.addr2 &&
                                <Typography
                                    level="body-xs">
                                 { identity.addr2 }
                                </Typography>
                                }
                                { (identity.city ||
                                    identity.state ||
                                    identity.zipcode) &&
                                    <Stack direction="row" spacing={0.5}>

                                <Typography
                                    level="body-xs">
                                    { identity.city }
                                </Typography>
                                <Typography
                                    level="body-xs">
                                    { identity.state }
                                </Typography>
                                <Typography
                                    level="body-xs">
                                    { identity.zipcode }
                                </Typography>
                                    </Stack>
                                }
                            </Stack>
                    }

                    {hasRole('support') &&

                        <Stack>
                            <Typography
                                sx={{ textTransform: 'uppercase' }}
                                level="body-xs">
                                SUPPORT INFO
                            </Typography>

                            <Typography level="body-xs"
                                endDecorator={<Chip>{identity.tasks_remaining}</Chip>}>
                                Tasks Remaining
                            </Typography>
                            </Stack>

                    }
                </Stack>

            </LockedFeature>

        </Stack>
    );
});
export default SidebarIdentityInfo;
